module.exports = __webpack_public_path__ + "a9e565f373b089f8dd08f1beaac450a7.png";